const router = {
  NEW_CADASTRO: 'cof/cadastroColetivo',
  RETIFICAR: 'cof/retificacaoCadastro',
  EDITAR: 'cof/cadastroColetivo'
}

export default {
  router
}



// WEBPACK FOOTER //
// ./src/utils/ma/regrasArrecadacao.js